import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=7bf4b1d4&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"
import style0 from "./user_info.vue?vue&type=style&index=0&id=7bf4b1d4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4b1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf4b1d4')) {
      api.createRecord('7bf4b1d4', component.options)
    } else {
      api.reload('7bf4b1d4', component.options)
    }
    module.hot.accept("./user_info.vue?vue&type=template&id=7bf4b1d4&scoped=true", function () {
      api.rerender('7bf4b1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/performance_manage/performace_target_report/components/user_info.vue"
export default component.exports